import mapboxgl from "mapbox-gl";
import 'mapbox-gl/dist/mapbox-gl.css';
import { AddExistingPoint } from "./ActivitesUtil";
import generatePDF, { Margin, Resolution } from "react-to-pdf";

import ReactDOMServer from "react-dom/server";

import { isMobile } from 'react-device-detect';

import * as htmlToImage from 'html-to-image';

import $ from 'jquery'
import axios from "axios";
import uniqid from "uniqid";
import jsPDF from "jspdf";
import React from "react";
//initial version
import html2canvas from "html2canvas";
import { SaveTemplate } from "./SaveUtil";
//version avec correction iOS https://www.npmjs.com/package/@xuannghia/html2canvas/v/1.4.2
//import html2canvas from "@xuannghia/html2canvas";


//html2canvas ne prend pas en compte les clip-path, alors on les transfère en image avec htmlToImage qui les gère
 function convertClipToImage(objItems  :any) {

    //on vient temporairement set 
    objItems.forEach(async (element: any) => {
      if (element.type == "cadre-element") {
        let imgToPrint = document.querySelector('#' + element.id + '.cadre-element') as HTMLElement;
        let srcToPush = document.querySelector('#img-' + element.id) as HTMLImageElement;

        //vérifier que le pixelRatio est juste
        await htmlToImage.toPng(imgToPrint, { quality: 1, pixelRatio: 4, skipFonts: true })
          .then(function (dataUrl) {
            srcToPush.src = dataUrl;

             //temporairement à width, height à 100% et transform à 0 le temps de la génération
            srcToPush.style.width = '100%';
            srcToPush.style.height = '100%';
            srcToPush.style.transform = '';    

          }).catch(function (error) {
            console.error('oops, something went wrong!', error);
            //$('div[class*=mapboxgl-ctrl]').show();
          });
      }
    });

  }

   function invertClipToImage(objItems  :any) {

    //reset elem src and style
    objItems.forEach(async (element: any) => {
      if (element.type == "cadre-element") {

        let srcToPush = document.querySelector('#img-' + element.id) as HTMLImageElement;

        //srcToPush.src = "http://localhost:3000/studio" + element.src;
        //srcToPush.src = process.env.REACT_APP_PUBLIC_URL + element.src;
        srcToPush.src = element.text === 'upload' ? element.src : process.env.REACT_APP_PUBLIC_URL + element.src
        if(element.cropCadre.sizePourcent.width != null) srcToPush.style.width = element.cropCadre.sizePourcent.width;
        if(element.cropCadre.sizePourcent.height != null) srcToPush.style.height = element.cropCadre.sizePourcent.height;
        if(element.cropCadre.transform != null) srcToPush.style.transform = element.cropCadre.transform;

      }
    });

  }

async function ExportPdf(download: boolean, imgFilename:any,  context: any) {

    const { objItems, selectedItem, setSelectedItem,
        mapListPoint, addMapListPoint,
        pageSize, jsonFormat, isPortrait, setIsPortrait,
        setIsImgPreview, setIsImgFinal, setImgFinal, imgElement, productName, afficheName } = context;

    //unselect selectedItem 
    //$('.selected-element').removeClass("selected-element");
    //cas spécial pour les bordure du texte
    $('.text-eleme-active').remove();
    //set selectedItem context to null !
    if (selectedItem != null && setSelectedItem != null) setSelectedItem(null);
    //disable mapbox text items
    $('div[class*=mapboxgl-ctrl]').hide();

    var init_zoom = getZoomValue();

    //gestion spécial Firefox et desktop
    if (navigator.userAgent.indexOf("Firefox") !== -1) {
        $('#editor').css({ '-moz-transform': 'scale(1)' });
    }
    /* a recomenté si on utilise zomm*/else /*if(!isMobile)*/ {
        $('#editor').css({ 'transform': 'scale(1)' });
    }

    const getTargetElement = () => document.getElementById('page');

    var imgName = imgFilename == null ? "affiche_" + productName + "_" + uniqid() + ".pdf" : imgFilename;

    const actualPixelRatio: number = window.devicePixelRatio;
    var map_init = (window as any).$map;
    var isMobilePixelRatioManipulate = false;
    /*if(isMobile)
        Object.defineProperty(window, "devicePixelRatio", { get: function () { return 400 / 96; } });*/
    
        //sur le téléphone on peut pas modifier le devicePixelRatio, ça foire tout, il faut prendre celui par défaut
        //on devra mettre un avertissement pour les mobiles qui ont un ratio trop faible !!

        //le width et height du canvas mapbox est multiplié par le pixel ratio! si on dépasse ça 4069 ça pète, il faut prévoir un truc
        //contre ça, ça bug que en manipulation, pas en export pdf (bug pour scroll etc..)
    
        if(!isMobile) Object.defineProperty(window, "devicePixelRatio", { get: function () { return 600 / 96; } });
        else if(isMobile && (window as any).$devicePixelRatioInitial != actualPixelRatio){
            Object.defineProperty(window, "devicePixelRatio", { get: function () { return (window as any).$devicePixelRatioInitial; } });
            isMobilePixelRatioManipulate = true;
        }

    //Convertir temporairement les clip path en image
     await convertClipToImage(objItems);

    const renderMap = new mapboxgl.Map({
        accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN != null ? process.env.REACT_APP_MAPBOX_ACCESS_TOKEN : "",
        container: document.getElementsByClassName('map-element')[0] as HTMLElement,
        style: map_init.getStyle(),
        center: map_init.getCenter(),
        zoom: map_init.getZoom(),
        bearing: map_init.getBearing(),
        pitch: map_init.getPitch(),
        interactive: false,
        preserveDrawingBuffer: true,
        fadeDuration: 0,
        attributionControl: false,
        projection : map_init.getProjection()
        //projection: { name: "mercator" },
        // hack to read transfrom request callback function
        //transformRequest: (this.map as any)._requestManager._transformRequestFn,
    });

    //On inverse avec la map temporaire
    (window as any).$map = renderMap;

    //on redissine chaque point sur la map temporaire
    mapListPoint.forEach((element: any) => {
        AddExistingPoint(element, true, { mapListPoint, addMapListPoint });
    });

    //On attend qu'elle soit générée
    renderMap.once('idle', async () => {

        setTimeout(async () => {
            var format;
            var orientation;

            if (jsonFormat.id != null && jsonFormat.id.includes('a4')) {
                format = 'a4';
                orientation = (isPortrait) ? 'portrait' : 'landscape';
            }
            //pour le a2 on exporte à a3 pour l'impression seulement
            else if (jsonFormat.id != null && (jsonFormat.id.includes('a3'))) {
                format = 'a3';
                orientation = (isPortrait) ? 'portrait' : 'landscape';
            }
            else if (jsonFormat.id != null && (jsonFormat.id.includes('a2'))) {
                format = 'a2';
                orientation = (isPortrait) ? 'portrait' : 'landscape';
            }
            else {
                format = [(pageSize.height * 25.4) / 200, (pageSize.width * 25.4) / 200]

                //la librairie prend le côté le plus grand comme hauteur
                //pour palier on n'est obligé de déduire l'orientation
                if (pageSize.height > pageSize.width && setIsPortrait != null) orientation = 'portrait';
                else if (setIsPortrait != null) orientation = 'landscape'

            }

            //keyword : react element to pdf
            //https://stackoverflow.com/questions/74830977/how-to-download-react-component-as-pdf-with-high-resolution

            const documentPDF = new jsPDF((orientation == 'portrait') ? 'portrait' : 'landscape', "mm", format, true);

            const pdfWidth = documentPDF.internal.pageSize.getWidth();
            const pdfHeight = documentPDF.internal.pageSize.getHeight();

            var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            console.log("isIOS: "+isIOS)

            await html2canvas(document.getElementById('page')!, {
                scale: (isIOS ? Math.min(window.devicePixelRatio, 2) : 4),
                //scale:  4,
                useCORS: true,
                logging:false,
              }).then(function (canvas) {
                var data = canvas.toDataURL("image/jpeg");
                documentPDF.addImage(data, "JPEG", 0, 0, pdfWidth, pdfHeight);
                //doc.save("label3.pdf");
              });

            //génératio du pdf
            /*const documentPDF = await generatePDF(getTargetElement, {
                filename: 'page1.pdf',
                method: "build",
                //method: "save",
                resolution: Resolution.MEDIUM,
                page: {
                    format: format,
                    orientation: (orientation == 'portrait') ? 'portrait' : 'landscape',
                    margin: Margin.NONE,
                },
                overrides: {
                    pdf: {
                        //ca marche pas
                        //unit: 'px',
                        //format: format,
                        hotfixes: ["px_scaling"]
                    },
                    canvas: {
                        imageTimeout: 15000,
                        //proxy: 'https://affichemap.fr',
                        logging: true
                    }
                }
            })*/

            //prévention si plus d'une page !
            documentPDF.deletePage(2);

            if(download){
                documentPDF.save(imgName);
            }
            else {
                const base64 = documentPDF.output("datauristring");

                const file = new File([documentPDF.output('blob')], imgName)

            const formData = new FormData();
            formData.append('upl', file);
            formData.append('name',  imgName);

            // Request made to the backend api
            // Send formData object
            axios.post(process.env.REACT_APP_URL_BACK+ "/api/upload-affiches", formData).then((response:any) => {

                if (response.status == 200) {

                    //case of client on studio
                    if (imgElement != null && imgElement.current != null) imgElement.current.src = process.env.REACT_APP_URL_BACK + "/" +response.data.preview;
                    if(setIsImgPreview != null) setIsImgPreview(true);
                    //pdf
                    if(setImgFinal != null) setImgFinal(response.data.pdf);
                    if(setIsImgFinal != null) setIsImgFinal(true);

                    //case of automatique compose
                    if(productName == "auto") {
                        //ajout d'un flag dans le body pour pupetteer
                        var baliseToset = document.querySelector('body');
                        if(baliseToset != null) baliseToset.insertAdjacentHTML("afterbegin", '<div id="isComposePDF">'+response.data.pdf+'</div>');
                        if(baliseToset != null) baliseToset.insertAdjacentHTML("afterbegin", '<div id="isComposePreview">'+response.data.preview+'</div>');

                    }

                }

            }, (error) => {
                console.log(error);
            });

            }

            //retour arrière, on supprime la map temporaire
            renderMap.remove();

            if (navigator.userAgent.indexOf("Firefox") !== -1) {
                $('#editor').css({ '-moz-transform': 'scale(' + init_zoom + ')' });
            }
            /**/else /*if(!isMobile)*/ {
                $('#editor').css({ 'transform': 'scale(' + init_zoom + ')' });
            }

            $('div[class*=mapboxgl-ctrl]').show();
            /*else if(!isMobile) {
                $('#editor').css({ 'transform': 'scale(' + init_zoom + ')' });
            }*/

            invertClipToImage(objItems);

            (window as any).$map = map_init;

            //on remet le pixel ratio initial
            if(!isMobile || isMobilePixelRatioManipulate) {
                Object.defineProperty(window, 'devicePixelRatio', {get() { return actualPixelRatio; },});
                isMobilePixelRatioManipulate = false;
            }


        }, 5000);

    });


}

async function ExportJSON(jsonName: any, context: any) {

    const { mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock,
        selectedItem, setSelectedItem, addMapListPoint, jsonFormat, setIsPortrait } = context;

    //unselect selectedItem 
    //cas spécial pour les bordure du texte
    $('.text-eleme-active').remove();
    //set selectedItem context to null !
    if (selectedItem != null && setSelectedItem != null) setSelectedItem(null);
    //disable mapbox text items
    $('div[class*=mapboxgl-ctrl]').hide();

    var exportJSON = SaveTemplate({ mapListPoint, objItems, pageSize, pageColor, mapPosition, mapIndex, mapTaille, mapUrlStyle, mapListTrace, elevationData, isMode3D, isPortrait, mapLock, jsonFormat })

    const json = JSON.stringify(exportJSON);
    const blob = new Blob([json], { type: "application/json" });

    //var jsonName = "affiche_" + uniqid() + ".json";

    const jsonfFile = new File([blob], jsonName)

    const formData = new FormData();

    formData.append('upl', jsonfFile);
    formData.append('compo', 'true');

    // Request made to the backend api
    // Send formData object
    const isSucess = await axios.post(process.env.REACT_APP_URL_BACK + "/api/upload-json", formData).then((response: any) => {

        if (response.status == 200) {
            //console.log(response.data.pdfName)
            //pdf
            //if (setImgFinal != null) setImgFinal(response.data.pdfName);

            return true;
        }

    }, (error) => {
        console.log(error);
        return false;
    });

    return isSucess;


}

function getZoomValue() {

    if (navigator.userAgent.indexOf("Firefox") !== -1) {
        var values = $('#editor').css("transform").replace("matrix(", "").replace(")", "").split(',');
        var a = parseFloat(values[0]);
        var b = parseFloat(values[1]);
        return Math.sqrt(a * a + b * b);
    }
    //else if (isMobile) return parseFloat($('#editor').css("zoom"));
    else {
        //remettre en commntaire
        /**/var values = $('#editor').css("transform").replace("matrix(", "").replace(")", "").split(',');
        var a = parseFloat(values[0]);
        var b = parseFloat(values[1]);
        return Math.sqrt(a * a + b * b);
        //return parseFloat($('#editor').css("zoom"));
    }
}


export { ExportPdf, ExportJSON };

 // Generate map clone with higher resolution

       //change marker mask to image
       //A METTRE DE COTE POUR PLUS TARD SVG MASK ETC
       /*for (const element of mapListPoint) {
           var marker = element.marker.getElement().querySelector('div')
           console.log(marker)

           var markerJQuery = $(marker);
           console.log(markerJQuery.css("transform"))

           
           var initTransform = markerJQuery.css("transform");
           console.log(marker.style)
           console.log(marker.style.transform)
           marker.style.transform = 'none'

           var imgGen = await htmlToImage.toPng(marker)
           .then(function (dataUrl) {
               var img = new Image();
               img.src = dataUrl;
               img.className = 'marker-finishflag1-transform'

               return img;
               

           })
           .catch(function (error) {
               console.error('oops, something went wrong!', error);
           });

           console.log(imgGen)
           marker.style.transform = initTransform

           element.markerImg = imgGen

           
       };*/

       //node[0].style.transform = 'none'

       /*var imgGen = await htmlToImage.toPng(node[0])
           .then(function (dataUrl) {
               var img = new Image();
               img.src = dataUrl;

               return img;
               

           })
           .catch(function (error) {
               console.error('oops, something went wrong!', error);
           });

           //var im = await genImg(node[0])
           mapListPoint.forEach((element: any) => {
               element.markerImg = imgGen
           });*/